import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faTwitter, faLinkedinIn, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import './Join.css';

class Join extends Component {
	render() {
		return (
		<div className='Join-content'>
			<Row className='justify-content-center px-3 mb-5'>
				<Col sm={12} className='px-0'>
					<h2 className='text-center'>Join the 2030 District</h2>
				</Col>
				<Col md={10} lg={8} xl={6}>
					<p>The <a href="https://www.2030districts.org/toronto">Toronto 2030 District</a> is:</p>
					<ul>
						<li className='pb-3'>A private-public initiative committed to achieving a low-carbon future for Toronto's downtown core</li>
						<li className='pb-3'>A broad network comprised of property owners and managers, tenants, utilities, government, service providers, and civil society</li>
						<li className='pb-3'>A member of 22 Districts in cities across North America working to achieve the Architecture 2030 Challenge targets.</li>
					</ul>
				</Col>
			</Row>
			<Row className='justify-content-center px-3 mb-5'>
				<Col md={9} lg={7} xl={5} className='text-center'>
					<p className='large'><strong>We aim to improve conservation effectiveness through better data, collaboration and industry leadership.</strong></p>
					<img className='col-sm-10 pt-4' src="images/toronto-2030-platform-infographic.jpg" alt='Toronto 2030 Platform Priorities' />
				</Col>
			</Row>	
			<Row className='justify-content-center px-3 py-5 bg-light'>
				<Col md={10} lg={8} xl={6}>
					<h3 className='text-center mb-3'>Become a Partner</h3>
					<p>2030 District partners understand that by working collectively toward the Toronto 2030 District goals they are improving their own assets and their neighbours’ as well as increasing the entire District’s value in the eyes of the community, tenants, and investors.</p>
					<p>By becoming a partner in the Toronto 2030 District, you recognize:</p>
						<ul><li>The importance of reducing district-wide greenhouse gas emissions</li>
							<li>That being part of a high-performance District has benefits for all District stakeholders</li>
							<li>That no one organization or sector can get there alone. We need collaborative, community-wide solutions</li>
							<li>That you are part of the solution and you are actively working to reduce your own emissions</li>
						</ul>
				</Col>
				<Col sm={12} className='px-3 py-3'>
					<h5 className='text-center mb-3'>Partnership Forms:</h5>
				</Col>
				<Col sm={8} md={3} xl={2} className='text-center px-3'>
					<a className="btn btn-secondary" href="https://www.2030districts.org/sites/default/files/atoms/files/A1-Toronto%202030%20District%2C%20Owners-Managers-Developers%20Partner%20Form.pdf" role="button"><FontAwesomeIcon icon={faFilePdf} /><br />Building Stakeholder<br /></a>
					<p className='pt-3'><h6>Includes:</h6>Building Owners, Property Managers, Developers, Major Tenants</p>
				</Col>
				<Col sm={8} md={3} xl={2} className='text-center px-3'>
					<a className="btn btn-secondary" href="https://www.2030districts.org/sites/default/files/atoms/files/A2-Toronto%202030%20District%2C%20Service%20Provider%20Partner%20Form_1.pdf" role="button"> 
					<FontAwesomeIcon icon={faFilePdf} /><br />Service Stakeholder</a>
					<p className='pt-3'><h6>Includes:</h6>Architects, Engineers, Designers, Consultants, Product Suppliers, Contractors, Service Providers</p>
				</Col>
				<Col sm={8} md={3} xl={2} className='text-center px-3'>
					<a className="btn btn-secondary" href="https://www.2030districts.org/sites/default/files/atoms/files/A3-Toronto%202030%20District%2C%20Community%20Partner%20Form_0.pdf" role="button">
				<FontAwesomeIcon icon={faFilePdf} /><br />Community Stakeholder</a>
				<p className='pt-3'><h6>Includes:</h6>Academia, Government, Non-Profit, Utilities</p>
				</Col>
			</Row>			
			<Row className='justify-content-center px-3 py-5'>
				<Col sm={12} className='social text-center'>
					<a href="https://twitter.com/TO_2030District"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>{'    '}
					<a href="https://www.linkedin.com/groups/8135789"><FontAwesomeIcon icon={faLinkedinIn} size='lg' /></a>{'    '}
					<a href="https://www.facebook.com/Toronto2030District/"><FontAwesomeIcon icon={faFacebookF} size='lg' /></a>
				</Col>
			</Row>
		</div>
		)
	}
}

export default Join;


// WEBPACK FOOTER //
// ./src/Join.js